export const API_URL = 'https://newsapi.org/v2'

export const SOURCES =
  'abc-news,al-jazeera-english,ars-technica,associated-press,bbc-news,bbc-sport,bleacher-report,bloomberg,business-insider,buzzfeed,cbc-news,cbs-news,cnn,espn,financial-post,fortune,fox-news,fox-sports,ign,independent,medical-news-today,msnbc,mtv-news,national-geographic,national-review,nbc-news,news24,new-scientist,newsweek,politico,reuters,talksport,techcrunch,techradar,the-huffington-post,the-verge,the-wall-street-journal,the-washington-post,the-washington-times,time,usa-today,vice-news,wired'

export const PAGE_SIZE = 25
